export const REWARD_ANIMATION_DURATION_MS = 3000;
